var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopupLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_367_4762",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_367_4762)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.6001C12.6627 3.6001 13.2 4.13736 13.2 4.8001V10.8001H19.2C19.8628 10.8001 20.4 11.3374 20.4 12.0001C20.4 12.6628 19.8628 13.2001 19.2 13.2001H13.2V19.2001C13.2 19.8629 12.6627 20.4001 12 20.4001C11.3373 20.4001 10.8 19.8629 10.8 19.2001V13.2001H4.8C4.13726 13.2001 3.6 12.6628 3.6 12.0001C3.6 11.3373 4.13726 10.8001 4.8 10.8001H10.8V4.8001C10.8 4.13736 11.3373 3.6001 12 3.6001Z",
    fill: "url(#paint0_linear_367_4762)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_4762",
    x1: 3.6,
    y1: 12.1218,
    x2: 20.4,
    y2: 12.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopupLight);
export default __webpack_public_path__ + "static/media/icon_topup_light.239d4dfb0eb6dd40c5f232a027b6b05b.svg";
export { ForwardRef as ReactComponent };